module.exports = __webpack_public_path__ + "img/341.3f1cce0d.png";